const mainNavigation = document.querySelector('#main-navigation');
const body = document.querySelector('body');
const navButton = document.querySelector('#nav-button');
if (mainNavigation) {
  navButton.addEventListener('click', function () {
    body.classList.toggle('nav-open');
    navButton.classList.toggle('open-menu');
    mainNavigation.toggleAttribute('open');
  });
}

// Product image gallery
const galleryMainImages = document.querySelectorAll('.gallery-main-image');
if (galleryMainImages.length) {
  document.querySelectorAll('.gallery-thumbnail').forEach((thumb) => {
    thumb.addEventListener('click', () => {
      const index = parseInt(thumb.dataset.index);
      galleryMainImages.forEach((img) => img.classList.remove('active'));
      galleryMainImages[index].classList.add('active');
      document.querySelectorAll('.gallery-thumbnail').forEach((t) => t.classList.remove('active'));
      thumb.classList.add('active');
    });
  });
}

